import * as React from 'react'

import { useAppDispatch } from '../../redux/hooks';
import { setInfoMap } from '../../redux/reduces/skuSlice'
import ProductSku from '../product-sku/sku-layout'
import SamplePayment from './sample-payment'

export default function SampleDialog(props: any) {
  const { sampleInfo, price, sampleInventory, i18n, sku, type, productId } = props;
  const {skuAttrs, skuInfoMap} = sku;
  const dispatch = useAppDispatch();

  // 库存计算
  let inventorySkuMap = {};
  if (sampleInventory) {
    const { samplePreferedDispatchId,
      sampleRepoSkuInventory = {} } = sampleInventory
    inventorySkuMap = sampleRepoSkuInventory[samplePreferedDispatchId]?.skuMap || {};
  }
  
    const { 
      formatPrice,
      formatOriginalPrice,
      skuList,
      maxQuantity
     } = sampleInfo;

    // 样品单ids
    const sampleSkuKeys = skuList.map((i: { id: any; }) => i.id).join(',');

    // 价格
    const {
        unit,
    } = price;
    const skuSampleInfo = {};
    // 样品单可选sku
    const sampleInfoMap = {};

    skuList.forEach( (i: { id: string | number; price: string; }) => {
        skuSampleInfo[i.id] = i;
    } );

    // 与主商品合并
    Object.keys( skuInfoMap ).forEach( i => {
      // 通过主商品属性过滤
      if (i.indexOf(skuAttrs[0].id) > 0 ) {
        return;
      }
      //通过样品sku过滤
        if (sampleSkuKeys.indexOf(skuInfoMap[i].id) > -1) {
          const skuItem = inventorySkuMap[skuInfoMap[i].id];
          sampleInfoMap[i] = {
              skuId: skuInfoMap[i].id,
              ...skuInfoMap[i],
              ...skuSampleInfo[skuInfoMap[i].id],
              productId,
              // 无仓库存储
              inventoryCount: Math.min(maxQuantity, skuItem?.inventoryCount >= 0 ? skuItem?.inventoryCount : 99999),
          }
          // 工单修复，样品无促销价格
          delete sampleInfoMap[i].promotionPrice;
          delete sampleInfoMap[i].formatPromotionPrice;
        }
    } )

    const sampleInfoMapKeys = Object.keys(sampleInfoMap).join(',');
    

    // 通过主商品过滤样品sku
    const sampleSkuAttrs = skuAttrs.map((_skuAttr: { values: any; id: any; }) => {
      const {values, id} = _skuAttr;
      return {
        ..._skuAttr,
        values: values.filter( (i: { id: any; }) => sampleInfoMapKeys.indexOf(`${id}:${i.id};`) > -1).map((item: any, index: number) => ({
          ...item,
          selected: index === 0
        }))
      }
    })
    

    dispatch( setInfoMap({
      type,
      info: sampleInfoMap
    }))

  return (<div className="sku-dialog">
        <div className="sku-layout">
            <div className="sku-header">
                <strong>{formatPrice}</strong>
                <span className="lower">/{unit}</span>
                <span>|</span>
                <span className="hight">
                    1 {unit}/{price.unitEven}
                </span>
                <span>{i18n['mainACtion_reference_mo']}</span>
                <p>
                  <del>{formatOriginalPrice}</del>
                </p>
            </div>
            <ProductSku {...props} skuAttrs={sampleSkuAttrs}/>

            </div>
            <SamplePayment {...props}/>
    </div>
  )
}
